export default __webpack_public_path__ + "media/images/user_photos/116-c9fc495b8f09bd8393ab7421fe27b92f.jpg";